import React from "react";
import Link from "next/link";
import {
  ContentCard,
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const cases = [
  {
    title: "Document-heavy intake",
    description:
      "Extract, validate, and route information from invoices, manifests, or claims into the systems operators already use.",
    outcome: "Hours of manual entry cut to minutes with review only on exceptions.",
  },
  {
    title: "Knowledge that stays findable",
    description:
      "Give teams grounded answers over policies, SOPs, and product docs without hunting through shared drives.",
    outcome: "Faster onboarding and fewer repeated questions to specialists.",
  },
  {
    title: "Operational assistants",
    description:
      "Agents that check status, update records, and escalate when judgment is required.",
    outcome: "Frontline teams spend more time on decisions, less on swivel-chair work.",
  },
  {
    title: "Workflow automation with humans in the loop",
    description:
      "Automate approvals and handoffs where rules and models both play a role, with clear ownership.",
    outcome: "Throughput rises without removing accountability.",
  },
  {
    title: "ERP and CRM assisted workflows",
    description:
      "Summaries, recommendations, and write-backs inside the platforms your teams already trust.",
    outcome: "Adoption without a parallel shadow system.",
  },
  {
    title: "Logistics exception triage",
    description:
      "Surface shipment context, documents, and next actions so operators clear exceptions faster.",
    outcome: "Smaller backlogs and clearer handoffs across partners.",
  },
];

function AiUseCases() {
  return (
    <LandingSection>
      <SectionHeader
        title="Selected scenarios we ship against"
        lead="Concrete problems with measurable outcomes. If your case looks different, we still start from the workflow."
      />

      <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {cases.map((item) => (
          <ContentCard
            key={item.title}
            title={item.title}
            description={`${item.description} ${item.outcome}`}
          />
        ))}
      </div>

      <p className="mt-10 text-sm text-ink-muted">
        Browse the full catalog on the{" "}
        <Link
          href="/use-cases"
          className="font-semibold text-[#1c8c80] no-underline hover:underline"
        >
          use cases page
        </Link>
        .
      </p>
    </LandingSection>
  );
}

export default AiUseCases;
